import React, { useEffect, useState } from "react";
import "./CancerModels.css";
import PDO from "./PDO";
import PDXO from "./PDXO";
import EtcModels from "./EtcModels";

// props 대신 { search }로 구조 분해 할당하여 코드를 더 깔끔하게 만듭니다.
function CancerModels({ search }) {

    // 1. 상태(State) 이름을 직관적으로 변경 (어떤 데이터를 담는지 알기 쉽게)
    const [pdoModels, setPdoModels] = useState([{ num: '' }]);
    const [pdxoModels, setPdxoModels] = useState([{ num: '' }]);
    const [etcModels, setEtcModels] = useState([{ num: '' }]);

    useEffect(() => {
        // 2. 프론트엔드에서 쿼리를 조립하던 로직 완전 삭제!
        // 이제 백엔드로 순수한 검색어(search)만 보냅니다.
        const reqOption = {
            method: "POST", // HTTP 메서드는 대문자로 쓰는 것이 표준 관례입니다.
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                param: search // 모든 요청이 동일하게 순수 검색어를 파라미터로 보냅니다.
            })
        };

        // 3. 세 번 따로 부르던 API를 Promise.all로 묶어서 동시에(병렬로) 처리합니다.
        // 이렇게 하면 네트워크 대기 시간이 확 줄어들어 화면이 더 빨리 뜹니다.
        const fetchAllModels = async () => {
            try {
                const [pdoData, pdxoData, etcData] = await Promise.all([
                    fetch("/api/CountPDOModels", reqOption).then(res => res.json()),
                    fetch("/api/CountPDXOModels", reqOption).then(res => res.json()),
                    fetch("/api/CountEtcModels", reqOption).then(res => res.json())
                ]);

                // 받아온 데이터를 각각의 상태에 업데이트
                setPdoModels(pdoData);
                setPdxoModels(pdxoData);
                setEtcModels(etcData);
            } catch (error) {
                console.error("모델 데이터를 불러오는 중 에러가 발생했습니다:", error);
            }
        };

        fetchAllModels();

    }, [search]); // 의존성 배열에는 search 하나만 들어갑니다.

    return (
        <div className="cancerModels">
            {
                pdoModels.map((item, index) => (
                    // React에서 배열을 map으로 그릴 때 key는 고유한 값이어야 합니다.
                    // index만 쓰기보다 접두사를 붙여주면 충돌을 더 확실히 방지할 수 있습니다.
                    <PDO num={item} search={search} key={`pdo-${index}`}></PDO>
                ))
            }
            {
                pdxoModels.map((item, index) => (
                    <PDXO num={item} search={search} key={`pdxo-${index}`}></PDXO>
                ))
            }
            {
                etcModels.map((item, index) => (
                    <EtcModels num={item} search={search} key={`etc-${index}`} />
                ))
            }
        </div >
    );
}

export default CancerModels;